import { extendTheme } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools"

const overrides = {
  initialColorMode: 'system', // 'light' / 'dark' / 'system'
  useSystemColorMode: true, // update with system
    styles: {
        global: (props: any) => ({
            body: {
                ".css-f6n2t5": { // buttons
                    minWidth: "auto",
                    bg: mode("teal.500", "gray.900")(props),
                    color: mode("white", "black")(props),
                },
            },
        }),
    },

    // override specific colors
    semanticTokens: {
        colors: {
          "teal.500": {
            _light: "rgb(49, 151, 149)", // default teal
            _dark: "cyan.500",
          },
          "teal.200": {
            _light: "teal.200",
            _dark: "cyan.200",   // special tones, like hover
          },
    },
  },
};

export default extendTheme(overrides);
